import { Button } from "@material-ui/core";
import React, { useState } from "react";

import { ScheduledJob } from "../../../../dtos/scheduledJob";
import { ScheduledJobType } from "../../../../enums/ScheduledJobType";

import { EditScheduledJobDialog } from "./Dialog";

interface Props {
    job: ScheduledJob;
    onJobSaved: (job: ScheduledJob) => void;
    availableJobTypes: ScheduledJobType[];
}

export function EditScheduledJobButton({ job, onJobSaved, availableJobTypes }: Props) {
    const [openDialog, setOpenDialog] = useState(false);

    return <>
        <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenDialog(true)}
        >
            Edit
        </Button>

        <EditScheduledJobDialog
            key={JSON.stringify(job)}
            job={job}
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onJobSaved={(job) => {
                setOpenDialog(false);
                onJobSaved(job);
            }}
            availableJobTypes={availableJobTypes}
        />
    </>;
}